import { render } from "./UploadSong.vue?vue&type=template&id=c6542e38"
import script from "./UploadSong.vue?vue&type=script&lang=js"
export * from "./UploadSong.vue?vue&type=script&lang=js"

import "./UploadSong.vue?vue&type=style&index=0&id=c6542e38&lang=css"
script.render = render

export default script